export function TagUserEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="152"
        viewBox="0 0 200 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 25C96.6667 33 96.6667 41 100 49"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M104 38H96C92.6863 38 90 40.6863 90 44V48C90 51.3137 92.6863 54 96 54H104C107.314 54 110 51.3137 110 48V44C110 40.6863 107.314 38 104 38Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M126 50H74C65.1634 50 58 57.1634 58 66V130C58 138.837 65.1634 146 74 146H126C134.837 146 142 138.837 142 130V66C142 57.1634 134.837 50 126 50Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 84C88 88.6667 92 88.6667 96 84"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 84C108 88.6667 112 88.6667 116 84"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 98C97.3333 102 102.667 102 108 98"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 96.5C80.1569 96.5 81.5 95.1569 81.5 93.5C81.5 91.8431 80.1569 90.5 78.5 90.5C76.8431 90.5 75.5 91.8431 75.5 93.5C75.5 95.1569 76.8431 96.5 78.5 96.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 96.5C120.157 96.5 121.5 95.1569 121.5 93.5C121.5 91.8431 120.157 90.5 118.5 90.5C116.843 90.5 115.5 91.8431 115.5 93.5C115.5 95.1569 116.843 96.5 118.5 96.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M78 124H122C121.204 124 120.441 123.947 119.879 123.854C119.316 123.76 119 123.633 119 123.5C119 123.367 119.316 123.24 119.879 123.146C120.441 123.053 121.204 123 122 123H78C78.7956 123 79.5587 123.053 80.1213 123.146C80.6839 123.24 81 123.367 81 123.5C81 123.633 80.6839 123.76 80.1213 123.854C79.5587 123.947 78.7956 124 78 124Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.75"
          d="M84 135H116C115.337 135 114.701 134.947 114.232 134.854C113.763 134.76 113.5 134.633 113.5 134.5C113.5 134.367 113.763 134.24 114.232 134.146C114.701 134.053 115.337 134 116 134H84C84.663 134 85.2989 134.053 85.7678 134.146C86.2366 134.24 86.5 134.367 86.5 134.5C86.5 134.633 86.2366 134.76 85.7678 134.854C85.2989 134.947 84.663 135 84 135Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M99.9998 18.9998C101.414 11.9288 107.071 9.10034 112.021 12.6359C109.192 18.2927 104.242 20.414 99.9998 18.9998Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M100 19.0001C94.3432 16.1717 93.6361 9.80775 97.8787 5.56511C102.121 9.80775 102.828 14.7575 100 19.0001Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M39 120L41 125L46 127L41 129L39 134L37 129L32 127L37 125L39 120Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M166 92.6004C167.436 92.6004 168.6 91.4363 168.6 90.0004C168.6 88.5644 167.436 87.4004 166 87.4004C164.564 87.4004 163.4 88.5644 163.4 90.0004C163.4 91.4363 164.564 92.6004 166 92.6004Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
